<template>
  <div class="back ml10" @click="goBack"><i class="icon iconfont el-icon-arrow-left"></i></div>
</template>

<script>
  export default{
    props: {
      assignURL: {
        type: String,
        default: ""
      },
    },
    mounted() {
   
    },
    methods:{
      goBack(){
        if(this.assignURL==""){
          history.back();
        }else{
           this.$router.push({name: this.assignURL});
        }
        
      }
    }
  }
</script>

<style scoped lang="scss">
  .back{
    cursor: pointer; 
    display: inline-block;
    color: #ffffff;
    background-color: #606266;
    border-radius: 4px;
    height: 20px;
    width: 20px;
    line-height: 20px;
  }
  .back i{
    font-size: 20px !important;
  }
</style>